export const GET_CONSOLIDATE_ORDER_LOADING = 'GET_CONSOLIDATE_ORDER_LOADING';
export const GET_CONSOLIDATE_ORDER_LOADING_ERROR =
  'GET_CONSOLIDATE_ORDER_LOADING_ERROR';
export const SET_CONSOLIDATE_DATA = 'SET_CONSOLIDATE_DATA';
export const SET_CONSOLIDATE_API_MODEL_DATA = 'SET_CONSOLIDATE_API_MODEL_DATA';
export const PROCESS_CONSOLIDATE_ORDER_LOADING =
  'PROCESS_CONSOLIDATE_ORDER_LOADING';
export const PROCESS_CONSOLIDATE_ORDER_LOADING_ERROR =
  'PROCESS_CONSOLIDATE_ORDER_LOADING_ERROR';
export const PROCESS_CONSOLIDATE_DATA = 'PROCESS_CONSOLIDATE_DATA';
export const CLEAR_CONSOLIDATE_ORDER_ERROR = 'CLEAR_CONSOLIDATE_ORDER_ERROR';
export const CLEAR_ORDER_CONSOLIDATE_VERIFICATION_MSG =
  'CLEAR_ORDER_CONSOLIDATE_VERIFICATION_MSG';



// WEBPACK FOOTER //
// ./src/pages/inventory/manageprocessorder/state/consolidate/types.js